// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__95vAs","clinicsSelect":"styles_clinicsSelect__2X40H"};